// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FSbh","fullView":"styles_fullView__1n63-"};